"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrganizers = exports.getOrganizer = exports.unfollowOrganizer = exports.followOrganizer = void 0;

var _normalizr = require("normalizr");

var _transformationUtils = require("@eb/transformation-utils");

var _http = require("js-utils/http");

var _urlLib = require("url-lib");

var ORGANIZERS_URL = '/api/v3/organizers/';

var organizerUrl = function organizerUrl(organizerId) {
  return "/api/v3/destination/organizers/".concat(organizerId, "/");
};

var followOrganizerUrl = function followOrganizerUrl(organizerId) {
  return "/api/v3/destination/organizers/".concat(organizerId, "/follow/");
};

var unfollowOrganizerUrl = function unfollowOrganizerUrl(organizerId) {
  return "/api/v3/destination/organizers/".concat(organizerId, "/unfollow/");
};

var _validateFollowed = function _validateFollowed(response) {
  if (response.followedByYou) {
    return response;
  }

  return Promise.reject();
};

var _validateUnfollowed = function _validateUnfollowed(response) {
  if (!response.followedByYou) {
    return response;
  }

  return Promise.reject();
};

var _transformResponse = function _transformResponse(response) {
  var schema = new _normalizr.Schema('results');
  var transformedContent = (0, _transformationUtils.transformUtil)({
    response: response,
    schema: schema
  });
  return transformedContent.entities.results[transformedContent.result];
};

var followOrganizer = function followOrganizer(organizerId) {
  return (0, _http.sdkRequest)(followOrganizerUrl(organizerId), {
    method: 'POST'
  }).then(_transformResponse).then(_validateFollowed);
};

exports.followOrganizer = followOrganizer;

var unfollowOrganizer = function unfollowOrganizer(organizerId) {
  return (0, _http.sdkRequest)(unfollowOrganizerUrl(organizerId), {
    method: 'POST'
  }).then(_transformResponse).then(_validateUnfollowed);
};

exports.unfollowOrganizer = unfollowOrganizer;

var getOrganizer = function getOrganizer(organizerId) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)(organizerUrl(organizerId), {
    'expand.destination_profile': 'image'
  })).then(_transformResponse);
};

exports.getOrganizer = getOrganizer;

var getOrganizers = function getOrganizers(organizerIds) {
  return (0, _http.sdkRequest)((0, _urlLib.formatUrl)(ORGANIZERS_URL, {
    ids: organizerIds,
    'expand.organizer': 'follow_status'
  }));
};

exports.getOrganizers = getOrganizers;
//# sourceMappingURL=organizer.js.map